import crypto from 'crypto'

export function createSha256Hash( valueToEncrypt ) {
    return crypto.createHash( 'sha256' ).update( JSON.stringify( valueToEncrypt ) ) .digest( 'hex' )
}